/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayLedStripColorSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, ledStripColor?: { __typename: 'ConfigLedStripColorState', reported: Types.ConfigLedStripColor } | null };

export type UpdateConfigLedStripColorMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateLedStripColorInput;
}>;


export type UpdateConfigLedStripColorMutation = { __typename: 'Mutation', configurationUpdateLedStripColor: { __typename: 'ConfigurationModel', id: string, ledStripColor?: { __typename: 'ConfigLedStripColorState', reported: Types.ConfigLedStripColor } | null } };

export const ConfigDisplayLedStripColorSelect_ConfigFragmentDoc = gql`
    fragment ConfigDisplayLedStripColorSelect_config on ConfigurationModel {
  id
  ledStripColor {
    reported
  }
}
    `;
export const UpdateConfigLedStripColorDocument = gql`
    mutation UpdateConfigLedStripColor($input: ConfigurationUpdateLedStripColorInput!) {
  configurationUpdateLedStripColor(input: $input) {
    ...ConfigDisplayLedStripColorSelect_config
  }
}
    ${ConfigDisplayLedStripColorSelect_ConfigFragmentDoc}`;
export type UpdateConfigLedStripColorMutationFn = ApolloReactCommon.MutationFunction<UpdateConfigLedStripColorMutation, UpdateConfigLedStripColorMutationVariables>;

/**
 * __useUpdateConfigLedStripColorMutation__
 *
 * To run a mutation, you first call `useUpdateConfigLedStripColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigLedStripColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigLedStripColorMutation, { data, loading, error }] = useUpdateConfigLedStripColorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConfigLedStripColorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConfigLedStripColorMutation, UpdateConfigLedStripColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateConfigLedStripColorMutation, UpdateConfigLedStripColorMutationVariables>(UpdateConfigLedStripColorDocument, options);
      }
export type UpdateConfigLedStripColorMutationHookResult = ReturnType<typeof useUpdateConfigLedStripColorMutation>;
export type UpdateConfigLedStripColorMutationResult = ApolloReactCommon.MutationResult<UpdateConfigLedStripColorMutation>;
export type UpdateConfigLedStripColorMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateConfigLedStripColorMutation, UpdateConfigLedStripColorMutationVariables>;